import { Homepage } from '../pages';
import { WithRouteData } from '../render-routes';

export const Home = () => <Homepage />;

export default WithRouteData(Home);
